import React from 'react'
import Header from '../../components/Navbar/Header'
import SampleBanner from '../../components/sampleComponents/sampleBanner/SampleBanner'
import Footer from '../../components/Footer/Footer'
import SampleSignUpForm from '../../components/sampleComponents/SamplesignUpForm/SampleSignUpForm'
import SelectRole from '../SelectRole'
import SecondHeader from '../../components/SecondHeader/SecondHeader'

const SampleSignUp = () => {
    return (
        <>
            {/* <Header /> */}
            <SecondHeader/>
            <SampleBanner />
            <SelectRole />
            <SampleSignUpForm />
            <Footer />
        </>
    )
}

export default SampleSignUp